import { render } from "./SideMenuLink.vue?vue&type=template&id=3bca842f"
import script from "./SideMenuLink.vue?vue&type=script&lang=js"
export * from "./SideMenuLink.vue?vue&type=script&lang=js"

import "./SideMenuLink.vue?vue&type=style&index=0&id=3bca842f&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__